module.exports = __webpack_public_path__ + "img/Rectangle_38.05364aa8.svg";